import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FieldId, MapState } from '@gk/gk-modules';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../../shared/base-new-request-form/base-new-request-form.model';
import { PARActType } from '../act-type/act-type.model';
import { PARRequestType } from '../request-type/request-type.model';

export enum PARNewRequestAdditionalControlName {
  Authority = 'authority',
  IsApplicantOwner = 'isApplicantOwner',
  ActType = 'actType',
  LetterContent = 'letterContent',
  LetterContentWithParcels = 'letterContentWithParcels',
  LetterDetails = 'letterDetails',
  RequestType = 'requestType',
  OwnerId = 'ownerId',
}

export enum PARLetterControlName {
  ActName = 'actName',
  IsAreaCoversAllParcels = 'isAreaCoversAllParcels',
  MapState = 'mapState',
}

export enum PARLetterContentAdditionalControlName {
  Content = 'content',
}

export const PARLetterContentControlName = {
  ...PARLetterControlName,
  ...PARLetterContentAdditionalControlName,
};

export enum PARLetterDetailsAdditionalControlName {
  LandUseClass = 'landUseClass',
  MaxBuildingCoverage = 'maxBuildingCoverage',
  MaxBuildingHeight = 'maxBuildingHeight',
  MinBiologicallyActiveArea = 'minBiologicallyActiveArea',
}

export const PARLetterDetailsControlName = {
  ...PARLetterControlName,
  ...PARLetterDetailsAdditionalControlName,
};

export const PARNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...PARNewRequestAdditionalControlName,
};

export interface PARNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [PARNewRequestControlName.Authority]: FormControl<string>;
  [PARNewRequestControlName.IsApplicantOwner]: FormControl<boolean>;
  [PARNewRequestControlName.ActType]: FormControl<PARActType>;
  [PARNewRequestControlName.LetterContent]: FormControl<string>;
  [PARNewRequestControlName.LetterContentWithParcels]: FormArray<
    FormGroup<PARLetterContentFormGroup>
  >;
  [PARNewRequestControlName.LetterDetails]: FormArray<
    FormGroup<PARLetterDetailsFormGroup>
  >;
  [PARNewRequestControlName.RequestType]?: FormControl<PARRequestType>;
  [PARNewRequestControlName.OwnerId]: FormControl<FieldId>;
}

export interface PARLetterContentFormGroup {
  [PARLetterContentControlName.Content]: FormControl<string>;
  [PARLetterContentControlName.ActName]: FormControl<string>;
  [PARLetterContentControlName.IsAreaCoversAllParcels]: FormControl<boolean>;
  [PARLetterContentControlName.MapState]: FormControl<MapState>;
}

export interface PARLetterDetailsFormGroup {
  [PARLetterDetailsControlName.LandUseClass]: FormControl<FieldId[]>;
  [PARLetterDetailsControlName.MaxBuildingCoverage]: FormControl<number>;
  [PARLetterDetailsControlName.MaxBuildingHeight]: FormControl<number>;
  [PARLetterDetailsControlName.MinBiologicallyActiveArea]: FormControl<number>;
  [PARLetterDetailsControlName.ActName]: FormControl<string>;
  [PARLetterDetailsControlName.IsAreaCoversAllParcels]: FormControl<boolean>;
  [PARLetterDetailsControlName.MapState]: FormControl<MapState>;
}
